import dayjs from 'dayjs';
import {IError} from '../../types/interface/Sinistres/assuranceVoyage';

export const showErrorValuesDefault = {
  numeroContrat: false,
  nomDeclarant: false,
  nomVictime: false,
  telephone: false,
  dateSinistre: false,
  heureAccident: false,
  lieuAccident: false,
  agence: false,
  circonstanceAccident: false,
  pieceJointeAgence: false,
  photo: false,
};

export const showErrorValuesSubmit = {
  numeroContrat: true,
  nomDeclarant: true,
  nomVictime: true,
  telephone: true,
  dateSinistre: true,
  heureAccident: true,
  lieuAccident: true,
  agence: true,
  circonstanceAccident: true,
  pieceJointeAgence: true,
  photo: true,
};

export const defaultSinistreVoyageError: IError = {
  numeroContrat: '',
  nomDeclarant: '',
  nomVictime: '',
  telephone: '',
  dateSinistre: '',
  heureAccident: '',
  lieuAccident: '',
  agence: '',
  circonstanceAccident: '',
  pieceJointeAgence: '',
  photo: '',
};

export const defaultSinistreVoyageValues = {
  numeroContrat: '',
  nomDeclarant: '',
  nomVictime: '',
  telephone: '',
  dateSinistre: dayjs().toDate(),
  heureAccident: dayjs().format('HH:mm'),
  lieuAccident: '',
  agence: '',
  circonstanceAccident: '',
  pieceJointeAgence: '',
  photo: '',
};

export const TitleLabels = {
  contractant: {
    nomPrenomContractant: 'Nom et prénom(s) du Contractant',
    dateNaissanceContractant: 'Date de naissance du Contractant ',
    cinContractant: 'Joindre CIN du Contractant',
    telephoneContractant: 'Téléphone du Contractant',
    emailContractant: 'Email Contractant',
    agence: 'Agence ARO (gestionaire du contrat)',
    premierVersement: 'Premier versement (Cotisation)',
    beneficiaireCasDeces: 'Nom du bénéficiaire en cas de décès',
  },
  assure: {
    nomPrenomAssure: "Nom et prénom(s) de l'Assuré ",
    dateNaissanceAssure: "Date de naissance de l'Assuré",
    adresseAssure: "Adresse de l'Assuré ",
    telephoneAssure: "Téléphone de l'Assuré ",
    emailAssure: "Email de l'Assuré",
    cinAssure: "Joindre CIN de l'assuré",
  },

  infos: {
    numeroContrat: 'Numéro de contrat',
    nomDeclarant: 'Nom du déclarant',
    nomVictime: 'Nom de la victime',
    telephone: 'N° téléphone',
    dateSinistre: "Date de l'accident",
    heureAccident: "Heure de l'accident",
    lieuAccident: "Lieu de l'accident",
    agence: 'Agence ARO gestionnaire du contrat',
    circonstanceAccident: "Circonstances et causes de l'accident",
    pieceJointeAgence: "Pièce(s) à fournir à joindre ou à déposer à l'agence",
    photo: "Photo(s) de l'accident",
  },
};
